// extracted by mini-css-extract-plugin
module.exports = {"user":"UserCol_user__2AV43","user__activity":"UserCol_user__activity__K981U","user__name":"UserCol_user__name__1GoLj"};